import React from 'react';
import { connectToStore } from '../../../store';
import styles from './SubscriptionDetails.module.scss';

function SubscriptionDetails() {
	return <div className={styles.subscriptionDetails}>Subscription Details - Work in Progress</div>;
}

export default connectToStore(SubscriptionDetails);
